import { Services } from '@Shared.Angular/@types/services';
import { IQService } from 'angular';

angular
  .module('flowingly.services')
  .factory('flowinglyHttpErrorInterceptor', flowinglyHttpErrorInterceptor);

flowinglyHttpErrorInterceptor.$inject = [
  '$q',
  'notificationService',
  'tokenService'
];

function flowinglyHttpErrorInterceptor(
  $q: IQService,
  notificationService: Services.NotificationService,
  tokenService: Services.TokenService
) {
  const messageDuration = 5000;

  //API
  const service = {
    requestError: requestError,
    responseError: responseError
  };

  return service;

  //////////// Public API Methods

  function requestError(rejection) {
    if (rejection.status !== 401) {
      notificationService.showErrorToast(
        'oops! sorry, error has occured',
        messageDuration
      );
    }

    return $q.reject(rejection);
  }

  function responseError(rejection) {
    if (rejection.status === 401) {
      tokenService.setUnauthorisedAccess(true); // Cant use sessionService here as that needs to use $http and so
      // there will be a circular depdendency
    } else {
      parseErrorsAndDisplay(rejection);
    }

    return $q.reject(rejection);
  }

  function parseErrorsAndDisplay(rejection) {
    //find any errors in the response and display in toast

    const badRequest = 400;
    const serverError = 500;

    if (rejection.status === badRequest || rejection.status === serverError) {
      // HACK FIX - we _might_ receive this type of output "[ERR_222] err"
      // in which case
      const data = rejection.data;
      const message = getErrorMessage(data);
      if (message) {
        const [all, errorCode, actualMsg] =
          /^(\[[a-zA-Z_0-9]+?\])? ?(.*)$/.exec(message);
        notificationService.showErrorToast(actualMsg, messageDuration);
        if (errorCode && isErrorObject(data)) {
          data.message = actualMsg;
          data.errorCode = errorCode.substr(1, errorCode.length - 2);
        }
      }
    } else {
      //handle everything else (most likely model validation errors on POST)

      const errors = [];
      const modelState = isErrorObject(rejection.data)
        ? rejection.data.modelState || rejection.data.ModelState || {}
        : {};
      for (const key in modelState) {
        for (let i = 0; i < modelState[key].length; i++) {
          errors.push(modelState[key][i]);
        }
      }

      if (isErrorObject(rejection.data) && rejection.data.error_description) {
        errors.push(rejection.data.error_description);
      }

      for (const key in errors) {
        notificationService.showErrorToast(errors[key], messageDuration);
      }
    }
  }

  function getErrorMessage(data: unknown): string | undefined {
    if (typeof data === 'string') {
      return data;
    }

    if (!isErrorObject(data)) {
      return undefined;
    }

    return (
      data.message || data.Message || data.errorMessage || data.ErrorMessage
    );
  }

  function isErrorObject(data: unknown): data is {
    [key: string]: any;
  } {
    return typeof data === 'object' && data !== null;
  }
}
